<script setup>
    /**
     * Vue Scripts
     */
    import {computed, ref} from "vue";
    import {glossaryStore} from "@pinia/glossary-store";
    import {apiFetch, updateLoading} from "@util/api";
    import {resetState} from "@util/util";

    /**
     * Vue Components
     */
    import SearchButton from "@component/SearchButton/SearchButton.vue";

    const {glossaryApi} = API;
    const {resetText} = GLOSSARY?.filter;
    const {label, placeholder} = GLOSSARY?.search;

    const store = glossaryStore();
    const query = computed(() => store.query)
    const searchValue = ref('')

    /**
     * Fetch the results when the user is actively
     * typing into the search input field
     */
    const searchQuery = () => {
        store.$patch({
            loading: true,
            query: {
                ...query.value,
                search: searchValue.value,
                page: 1,
            },
            results: [],
        })

        apiCall()
    }

    const apiCall = async () => {
        // Make API call here
        await apiFetch(glossaryApi, query.value)
            .then(({data, status}) => status === 200 && store.$patch(data))
            .finally(() => updateLoading(store, false))
    }

    /**
     * Resets the search state to the default
     */
    const resetSearch = () => {
        resetState(store)
        updateLoading(store, true)
        searchValue.value = '';
        apiCall()
    }

</script>

<template>
    <div class="glossary-search">
        <div class="form-items">
            <div class="glossary-search__search">
                <label
                    class="screen-reader-only"
                    for="glossary-input"
                    v-html="label"
                />

                <input
                    v-model="searchValue"

                    :placeholder="placeholder"

                    class="glossary-search-input"
                    id="glossary-input"
                    type="text"

                    @input="searchQuery"
                />

                <SearchButton
                    class="glossary-search__button"
                    :button-text="label"
                    @clickAction="searchQuery"
                />
            </div>
        </div>
        <button
            class="reset"
            v-html="resetText"

            @click.prevent="resetSearch"
        />
    </div>
</template>

<script>
    export default {
        name: "Glossary Search"
    }
</script>

<style scoped lang="scss">
    .glossary-search {
        &__search {
            display: flex;
            margin-bottom: 15px;
        }

        &-input {
            flex: 1 0 auto;
            margin-bottom: 0;
        }

        &__button {
            margin-left: 0.5rem;
        }

    }
</style>
